<template>
    <header class="tpl-head-wrap">
        <div class="tpl-head-logo">
            <a href="/">
                <img src="/assets/img/home/ixion/logo-top.jpg" alt="云南新东方烹饪美食培训">
            </a>
            <div class="tpl-head-sidebar-open"></div>
        </div>
        <nav class="tpl-head-sidebar">
            <ul class="tpl-head-sidebar-mask">
                <li>
                    <div class="tpl-head-sidebar-close">×</div>
                    <div class="tpl-head-sidebar-content">
                        <h2>云南新东方烹饪美食培训</h2>
                        <p>专注特色美食短期培训</p>
                    </div>
                </li>
                <li>
                    <i></i>
                    <a href="/custom_page/about-us/">学校概况</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/zt/xlzs/">学籍证</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/18pros/czqd">课程专业</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/zt/jybz/">就业保障</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/a/teacher/">名师大厨</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/zt/lxlx/">来校路线</a>
                </li>
                <li>
                    <i></i>
                    <a href="http://m.ynxdfpr.com/zly/leanmony/">学费标准</a>
                </li>
                <li>
                    <i></i>
                    <a href="javascript:void(0);" onclick="zixun()">在线咨询</a>
                </li>
            </ul>
        </nav> 
    </header>
</template>

<script>
export default {
    methods:{
        getStyle(obj, attr){
            return obj.currentStyle? obj.currentStyle[attr] : getComputedStyle(obj)[attr];
        }
    },
    mounted(){
        let This = this;
        // 头部右侧导航功能块
        let sideWrap = document.querySelector('.tpl-head-sidebar'); // 遮罩盒子
        let sideMask = document.querySelector('.tpl-head-sidebar-mask'); // 遮罩层
        let sideClose = document.querySelector('.tpl-head-sidebar-close'); // 关闭
        let sideOpen = document.querySelector('.tpl-head-sidebar-open'); // 打开
        let speed = 0;
        let sidew = parseFloat( this.getStyle(sideMask, 'width') );
        // 关闭
        sideClose.addEventListener('click', function () {
            let timer = setInterval(function(){
                speed += 30;
                if (speed > sidew ) {
                    clearInterval( timer );
                    sideWrap.style.display = 'none';
                    speed = 0;
                }
                sideMask.style.right = -speed + 'px';
            },30)   
        })
        // 打开
        sideOpen.addEventListener('click', function () {
            let sw = parseFloat( This.getStyle(sideMask, 'width') );
            let timer = setInterval(function(){
                sw -= 30;
                sideWrap.style.display = 'block';
                if (sw < 0 ) {
                    sw = 0;
                    clearInterval( timer );
                }
                sideMask.style.right = -sw + 'px';
            },30)  
        })
    }
}
</script>

<style lang="less" scoped>
// 初始化设计图尺寸 注意：less 除法要用小括号括起来
@rem: 40rem;
@w100: (640/@rem);
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: (@w/@rem);
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: (@radius/@rem) (@radius/@rem) (@radius/@rem) (@radius/@rem);
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: (@lineHeight/@rem);
    font-size: (@fontSize/@rem);
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: (@h/@rem);
        }
    }
}
.tpl-head-wrap{
    width: @w100;
    position: relative;
    .tpl-head-logo{
        .auto(630);
        .aimg(85);
        .tpl-head-sidebar-open {
            width: (50/@rem);
            height: (50/@rem);
            position: absolute;
            top: (13/@rem);
            right: (13/@rem);
        }
    }
    .tpl-head-sidebar{
        width: @w100;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 50%;
        z-index: 99999999;
        display: none;
        transform: translateX(-50%);
        ul{
            position: absolute;
            top: 0;
            right: (-320/@rem);
            width: (320/@rem);
            height: 100%;
            background: #fff;
            li{
                line-height: (60/@rem);
                position: relative;
                border-bottom: 1px solid #c6c6c6;
                i{
                    width: (30/@rem);
                    height: (30/@rem);
                    display: block;
                    position: absolute;
                    top: (20/@rem);
                    left: (25/@rem);
                }
                a{
                    display: block;
                    .linefont(60, 25, #000);
                    text-indent: (66/@rem);
                    text-align: left; // vue 中设置
                }
                .tpl-head-sidebar-content{
                    padding-top: (35/@rem);
                    h2,p{
                        .linefont(40, 24, #fff);
                        text-align: left;
                        text-indent: (20/@rem);
                    }
                }
                .tpl-head-sidebar-close {
                    .linefont(60, 30, #fff);
                    position: absolute;
                    top: (10/@rem);
                    right: (10/@rem);
                }
                &:nth-of-type(1) {
                    height: (140/@rem);
                    background: #795548;
                }
                &:nth-of-type(2) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/1.png');
                }
                &:nth-of-type(3) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/2.png');
                }
                &:nth-of-type(4) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/3.png');
                }
                &:nth-of-type(5) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/4.png');
                }
                &:nth-of-type(6) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/5.png');
                }
                &:nth-of-type(7) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/6.png');
                }
                &:nth-of-type(8) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/7.png');
                }
                &:nth-of-type(9) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/8.png');
                }
                &:nth-of-type(10) i{
                    .backgroundUrl('http://m.ynxdfpr.com/zly/publicLi010/sideicon/sicon02/9.png');
                }
            }
        }
    }
}
</style>